"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadePickerMode = exports.OpenFeedShadePicker = exports.Name = void 0;
const Name = exports.Name = 'open-shade-picker';
const OpenFeedShadePicker = exports.OpenFeedShadePicker = Name;
let ShadePickerMode = exports.ShadePickerMode = /*#__PURE__*/function (ShadePickerMode) {
  ShadePickerMode["Favorites"] = "favorites";
  ShadePickerMode["QuickBuy"] = "quickBuy";
  return ShadePickerMode;
}({}); // Has to match ProductShade from @ori/presentation-components
